import { Box } from "@chakra-ui/react";
import axios from "axios";
import { useEffect, useState } from "react";
import subsrt from "subsrt-ts";
import { Caption, ContentCaption } from "subsrt-ts/dist/types/handler";

export interface ISubtitlesProps {
    path: string | null;
    currentSeconds: number;
}

export function Subtitles({ path, currentSeconds }: ISubtitlesProps) {
    // The fetched data remembers which path it belongs to instead of being
    // reset synchronously in the effect (react-hooks/set-state-in-effect).
    const [subtitleData, setSubtitleData] = useState<{ path: string; data: Caption[] } | null>(null);

    useEffect(() => {
        if (!path) {
            return;
        }

        let cancelled = false;
        (async () => {
            const response = await axios.get(path);
            if (cancelled) {
                return;
            }
            const data = subsrt.parse(response.data);
            setSubtitleData({ path, data });
        })();
        return () => {
            cancelled = true;
        };
    }, [path]);

    const relevantData = subtitleData && subtitleData.path === path ? subtitleData.data : null;

    if (!path || !relevantData) {
        return <></>;
    }

    const currentSubtitles = relevantData.filter(
        (caption) =>
            caption.type === "caption" &&
            currentSeconds * 1000 >= caption.start &&
            currentSeconds * 1000 <= caption.end,
    ) as ContentCaption[];

    return (
        <div className="subtitles">
            {currentSubtitles.map((caption, index) => {
                const contentCaption = caption as ContentCaption;

                if (currentSeconds * 1000 >= contentCaption.start && currentSeconds * 1000 <= contentCaption.end) {
                    return (
                        <Box
                            key={index}
                            maxW="100%"
                            textAlign="center"
                            mt={8}
                            bg="rgba(0,0,0,0.6)"
                            px={4}
                            rounded="md"
                            fontSize="1.5cqw"
                        >
                            {contentCaption.text}
                        </Box>
                    );
                }

                return null;
            })}
        </div>
    );
}
